import { clsx } from 'clsx'

import { useI18n } from '@tribeplatform/react-components/i18n'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'
import { TopBarButton } from '@tribeplatform/react-ui-kit/TopBar'

import { useSearchBar } from '../providers/SearchBarProvider.js'

export const SearchButton = () => {
  const { $t } = useI18n()
  const { setSearchOpen, hasSearchSection } = useSearchBar()

  return (
    <div
      className={clsx(
        'h-full hidden justify-center items-center shrink-0',
        !hasSearchSection && 'lg:flex',
      )}
    >
      <TopBarButton
        onClick={() => setSearchOpen(true)}
        aria-label={$t({
          id: 'Generics.Search',
          defaultMessage: 'Search',
        })}
        icon={<SvgIcon name="search" />}
      />
    </div>
  )
}
